import sdk from '@psp-aggregator/sdk';

export const useProviderOfferCapabilities = (providerId: string) =>
  sdk.queries.useGetProviderOfferCapabilities(providerId, {
    enabled: providerId.length > 0,
  });
